/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { FormContext } from "../components/FormFull";
export default function useButton(props) {
    var ffHandler = React.useContext(FormContext);
    var _a = React.useState(!!props.feedback && !!(ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.getDisabledForm())), formDisabled = _a[0], setDisabled = _a[1];
    var _b = React.useState(false), formLoading = _b[0], setLoading = _b[1];
    var buttonName = React.useRef(props.feedback ? Math.random() + "-" + new Date().getTime() : undefined);
    var mount = React.useCallback(function () {
        if (props.feedback && buttonName.current) {
            ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.setNewButton(buttonName.current, {
                setDisabled: function (disabled) { return setDisabled(disabled); },
                setLoading: function (loading) { return setLoading(loading); },
                action: props.action,
            });
        }
        return function () {
            if (props.feedback && buttonName.current) {
                ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.removeButton(buttonName.current);
            }
        };
    }, [ffHandler, props, setDisabled, setLoading, buttonName]);
    React.useEffect(mount, []);
    var onClick = React.useCallback(function (event) {
        if (props.action === "submit") {
            ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.submit();
        }
        else if (props.action === "clear") {
            ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.clearFields(false);
        }
        else if (props.action === "clearDefault") {
            ffHandler === null || ffHandler === void 0 ? void 0 : ffHandler.clearFields(true);
        }
        if (props.onClick) {
            props.onClick(event);
        }
    }, [props, ffHandler]);
    return { onClick: onClick, ffHandler: ffHandler, formDisabled: formDisabled, formLoading: formLoading };
}
